import JSnackbar from '@atoms/JSnackbar';
import React, { createContext, useState, useMemo } from 'react';

export type SnackbarType = 'success' | 'error' | 'info' | 'warning';

interface SnackbarData {
  open: boolean;
  message: string;
  type: SnackbarType;
}

interface SnackbarContextProps {
  showSnackbar: (message: string, type: SnackbarType) => void;
}

export const SnackbarContext = createContext<SnackbarContextProps | undefined>(
  undefined,
);

export const SnackbarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [snackbarData, setSnackbarData] = useState<SnackbarData | null>(null);

  const showSnackbar = (message: string, type: SnackbarType) => {
    setSnackbarData({ open: true, message, type });
  };

  const closeSnackbar = () => {
    setSnackbarData(null);
  };
  const contextValue = useMemo(() => {
    return { showSnackbar };
  }, [showSnackbar]);

  return (
    <SnackbarContext.Provider value={contextValue}>
      {children}
      {snackbarData && (
        <JSnackbar
          open={snackbarData.open}
          message={snackbarData.message}
          type={snackbarData.type}
          onClose={closeSnackbar}
        />
      )}
    </SnackbarContext.Provider>
  );
};
